// @material-tailwind/react components
import { Typography } from "@material-tailwind/react";

// import SectionSubscribe from "components/sections/subscribe";

export default function Footer() {
  const year = new Date().getFullYear();

  // const socialMedia = [
  //   {
  //     icon: "fab fa-twitter",
  //     color: "text-light-blue-400",
  //     link: "https://www.twitter.com/creativetim?ref=material-tailwind",
  //   },
  //   {
  //     icon: "fab fa-facebook-square",
  //     color: "text-light-blue-600",
  //     link: "https://www.facebook.com/creativetim?ref=material-tailwind",
  //   },
  //   {
  //     icon: "fab fa-dribbble",
  //     color: "text-pink-400",
  //     link: "https://www.dribbble.com/creativetim?ref=material-tailwind",
  //   },
  //   {
  //     icon: "fab fa-github",
  //     color: "text-gray-900",
  //     link: "https://www.github.com/creativetimofficial?ref=material-tailwind",
  //   },
  //   {
  //     icon: "fab fa-discord",
  //     color: "text-blue-700",
  //     link: "https://discord.com/invite/gxtg2rJa?ref=material-tailwind",
  //   },
  // ];

  const friendlyLink = [
    {
      name: "构思白板",
      link: "https://gsbb.net",
    },
    {
      name: "IT 服务器中心",
      link: "https://itserverhub.net",
    },
    {
      name: "猫侠网络",
      link: "https://maoxiasoft.com",
    },
    // {
    //   name: "Github",
    //   link: "https://github.com/creativetimofficial?ref=material-tailwind",
    // },
    // {
    //   name: "Free Products",
    //   link: "https://www.creative-tim.com/templates/free?ref=material-tailwind",
    // },
  ];

  // const resources = [
  //   {
  //     name: "MIT License",
  //     link: "https://github.com/creativetimofficial/material-tailwind/blob/main/LICENSE.md?ref=material-tailwind",
  //   },
  //   {
  //     name: "Contribute",
  //     link: "https://github.com/creativetimofficial/material-tailwind/blob/main/CONTRIBUTING.md?ref=material-tailwind",
  //   },
  //   {
  //     name: "Code of Conduct",
  //     link: "https://github.com/creativetimofficial/material-tailwind/blob/main/CODE_OF_CONDUCT.md?ref=material-tailwind",
  //   },
  //   {
  //     name: "Contact Us",
  //     link: "https://www.creative-tim.com/contact-us?ref=material-tailwind",
  //   },
  // ];

  return (
    <footer className="bg-gray-100 relative z-50 pt-16 pb-6 text-[#1A237E]">
      {/* <SectionSubscribe /> */}
      <div className="container mx-auto">
        <div className="flex flex-wrap">
          <div className="w-full px-4 md:w-6/12">
            <Typography variant="h3" color="inherit" className="mb-2">
              技术池
            </Typography>
            <Typography
              variant="h5"
              color="inherit"
              className="mt-0 mb-2 text-lg font-normal opacity-60"
            >
              高效编程&开心编程，使用技术开创新世界.
            </Typography>
            {/* <div className="mt-6">
              {socialMedia.map(({ icon, color, link }, key) => (
                <a key={key} href={link} target="_blank" rel="noreferrer">
                  <i
                    className={`${icon} ${color} font-lg align-center mr-2 inline-block items-center justify-center rounded-full bg-white p-3 text-center shadow-lg outline-none focus:outline-none`}
                  />
                </a>
              ))}
            </div> */}
          </div>
          <div className="w-full px-4 md:w-6/12">
            <div className="items-top mb-6 flex flex-wrap">
              <div className="w-6/12 pt-6 md:ml-auto md:px-4 md:pt-0 xl:w-4/12">
                <span className="mb-2 block text-lg font-bold text-[#1A237E]">
                  友情链接
                </span>
                <ul className="list-unstyled">
                  {friendlyLink.map(({ name, link }, key) => (
                    <li key={key}>
                      <a
                        href={link}
                        target="_blank"
                        rel="noreferrer"
                        className="block pb-2 text-sm font-normal text-[#1A237E]/60"
                      >
                        {name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              {/* <div className="ml-auto w-6/12 pt-6 md:px-4 md:pt-0 xl:w-4/12">
                <span className="mb-2 block text-lg font-bold text-[#1A237E]">
                  Other Resources
                </span>
                <ul className="list-unstyled">
                  {resources.map(({ name, link }, key) => (
                    <li key={key}>
                      <a
                        href={link}
                        target="_blank"
                        rel="noreferrer"
                        className="block pb-2 text-sm font-normal text-[#1A237E]/60"
                      >
                        {name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div> */}
            </div>
          </div>
        </div>
        <hr className="border-gray-300 my-4" />
        <div className="flex flex-wrap items-center justify-center gap-2 md:justify-between">
          <div className="w-full px-4 text-center md:px-0 md:text-right">
            <ul className="flex flex-wrap text-blue-gray-300 text-sm">
              <li>Copyright &copy; {year} JiShuChi.cn</li>
              <li className="ml-2">
                <a
                  href="http://beian.miit.gov.cn/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-inherit transition-all"
                >
                  粤ICP备2024236883号-4
                </a>
              </li>
              <li className="ml-2">粤公网安备44010602012987号</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
